module.exports = __webpack_public_path__ + "img/debate234.737d9e3d.jpg";